// ---------------------------------------------------------
// Code copied from Arcade demo

const JourneysDemo = () => {
  return (
    <div
      style={{
        position: "relative",
        paddingBottom: "calc(50.431372549019606% + 41px)",
        height: 0,
        width: "100%"
      }}
    >
      <iframe
        src="https://demo.arcade.software/5sTqIfAhiZwNfMsVoIXH?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
        title="Build Omni-Channel Journeys"
        loading="lazy"
        allowFullScreen
        allow="clipboard-write"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          colorScheme: "light"
        }}
      />
    </div>
  )
}

export default JourneysDemo
